import React from 'react';
import { LucideIcon } from 'lucide-react';
import Card from '../ui/Card.tsx';

interface StatsCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: LucideIcon;
  iconColor?: string;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  loading?: boolean;
}

export default function StatsCard({
  title,
  value,
  subtitle,
  icon: Icon,
  iconColor = 'text-blue-400',
  trend,
  loading = false
}: StatsCardProps) {
  if (loading) {
    return (
      <Card variant="interactive" padding="md">
        <div className="animate-pulse">
          <div className="h-4 bg-gray-700 rounded w-20 mb-3" />
          <div className="h-8 bg-gray-700 rounded w-28 mb-2" />
          <div className="h-3 bg-gray-700 rounded w-24" />
        </div>
      </Card>
    );
  }

  return (
    <Card variant="interactive" padding="md">
      <div className="flex items-start justify-between mb-2">
        <span className="text-sm text-gray-400">{title}</span>
        {Icon && (
          <div className={`p-1.5 rounded-lg bg-gray-800 ${iconColor}`}>
            <Icon className="w-4 h-4" />
          </div>
        )}
      </div>

      <div className="flex items-baseline gap-2">
        <span className="text-2xl font-bold text-white tabular-nums">
          {value}
        </span>
        {trend && (
          <span
            className={`text-sm font-medium ${
              trend.isPositive ? 'text-green-400' : 'text-red-400'
            }`}
          >
            {trend.isPositive ? '+' : ''}{trend.value}%
          </span>
        )}
      </div>

      {subtitle && (
        <p className="text-xs text-gray-500 mt-1">{subtitle}</p>
      )}
    </Card>
  );
}
